/**
 * Header title region: displays the current page title.
 *
 * @module components/HeaderTitle
 */

import React from 'react';

/**
 * Renders the page title in the center of the header.
 *
 * @param {object} props
 * @param {string} props.title - The page title to display.
 * @returns {React.ReactElement}
 */
export default function HeaderTitle({ title }) {
  return (
    <div className="header-title">
      {title}
    </div>
  );
}
